import React, {useEffect} from "react";

type ModalProps = {
    title: string,
    text?: string,
    component?: React.ReactNode | null,
    onClose: () => void,
    isOpen?: boolean,
    isFullScreen?: boolean,
}
const Modal = ({title, text,  isOpen = false, onClose , component, isFullScreen = false}: ModalProps) => {

    const [isShow, setIsShow] = React.useState(false);
    const modalRef = React.useRef<HTMLDivElement>(null);

    useEffect(()  => {
        setIsShow(isOpen);
        if (isOpen) {
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        } else {
            document.getElementsByTagName('html')[0].style.overflow = '';
        }
    }, [isOpen])

    const onModalClose = () => {
        console.log(document.getElementsByTagName('body')[0]);
        document.getElementsByTagName('html')[0].style.overflow = '';
        onClose();
    }

    return <div
        className={`modal fixed inset-0 z-[100] flex flex-col ${!isFullScreen && 'justify-center'} items-center overflow-hidden px-4 py-6 sm:px-5 ${isShow && 'show'}`}
        role="dialog"
    >
        <div className="modal-overlay absolute inset-0 bg-slate-900/60"></div>
        <div style={{background: '#fff', zIndex: 100, borderRadius: '50%', marginBottom: '10px', width: '1.75rem'}}>
            <button  onClick={() => onModalClose()}
                     className="btn -mr-1.5 h-7 w-7 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4.5 w-4.5" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>
        </div>
        <div className={`modal-content scrollbar-sm relative flex ${isFullScreen ? 'w-full h-full' : 'max-w-screen-lg'} flex-col pb-8 overflow-y-auto rounded-lg bg-white px-4 dark:bg-navy-700 sm:px-5`}>
            <div className={"my-3 flex justify-between"}>
                <h2 className="font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    {title}
                </h2>
            </div>
            <div className={isFullScreen ? 'h-full' : ''}>
                {/*<h2 className="text-2xl text-slate-700 dark:text-navy-100 text-center">{title}</h2>*/}
                { text && <div className={`mt-2 ${isFullScreen && 'h-full'}`} dangerouslySetInnerHTML={{ __html: text }}></div>}
                { component }
                {/*<button onClick={() => onModalClose()} className="btn mt-6 bg-success font-medium text-white hover:bg-success-focus focus:bg-success-focus active:bg-success-focus/90">
                    Закрыть
                </button>*/}
            </div>
        </div>
    </div>

}

export default Modal;
